import { E_ObservationValueType } from "../../../../../enums/observation/observation-value-type.enum";
import { I_ObservationTextRule } from "../api/observation-text-rule.response";

export class ObservationTextRule {
    valueType: E_ObservationValueType;
    value: string;
    matchText?: string;
    matchBoolean?: boolean;
    matchNumber?: number;
    matchDate?: Date; // ISO date
    label?: string;
    minDate?: Date; // ISO date
    maxDate?: Date; // ISO date   
    minNum?: number;
    maxNum?: number;
    constructor(rule: I_ObservationTextRule) {
        this.valueType = rule.valueType;
        this.value = rule.value;
        this.matchText = rule.matchText;
        this.matchBoolean = rule.matchBoolean;
        this.matchNumber = rule.matchNumber;
        if (rule.matchDate) this.matchDate = new Date(rule.matchDate);
        this.label = rule.label;
        if (rule.minDate) this.minDate = new Date(rule.minDate);
        if (rule.maxDate) this.maxDate = new Date(rule.maxDate);
        this.minNum = rule.minNum;
        this.maxNum = rule.maxNum;
    }
}